import React from "react";
import { Navigate, useSearchParams } from "react-router-dom";

/**
 * Legacy confirmation route. Prefer /email-subscriptions?token=...
 * If a token is present, forward there; otherwise show a generic message.
 */
export default function UnsubscribedConfirmation(): React.ReactElement {
  const [searchParams] = useSearchParams();
  const token = (searchParams.get("token") ?? "").trim();
  if (token) {
    return (
      <Navigate
        to={`/email-subscriptions?token=${encodeURIComponent(token)}`}
        replace
      />
    );
  }

  return (
    <main
      className="min-h-[60vh] flex items-center justify-center p-6"
      style={{ background: "#f4f4f4" }}
    >
      <div
        className="max-w-md w-full bg-white rounded-lg shadow-md p-8 text-center"
        role="alert"
        aria-live="polite"
      >
        <h1 className="text-xl font-semibold text-gray-900 mt-0 mb-4">
          You have been successfully unsubscribed
        </h1>
        <p className="text-gray-600 text-sm leading-relaxed">
          You will no longer receive emails for this subscription. If this was a
          mistake or you wish to manage your preferences, please use the link
          from a recent email or contact your administrator.
        </p>
      </div>
    </main>
  );
}
